import { createUseStyles } from 'react-jss'
import {
  neonLime,
  black,
  neonLimeLight,
  neonLimeDark
} from '../../../styles/colors'
import ContentLimits from '../../../styles/ContentLimits'
import MediaQueries from '../../../styles/MediaQueries'

const useStyles = createUseStyles({
  invitationImage: {},
  invitationSplit: {
    display: 'none'
  },
  highlight: {
    display: 'inline',
    color: neonLime
  },
  responsiveOverlay: {
    display: 'flex',
    justifyContent: 'center',
    '& > *': {
      flex: 1
    }
  },
  invitationOverlay: {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    maxWidth: '450px'
  },
  logo: {
    width: '140px'
  },
  header: {
    fontFamily: 'GTWalsheim',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '100%',
    textAlign: 'center'
  },
  text: {
    fontFamily: 'GTWalsheim',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '100%',
    textAlign: 'center'
  },
  signUpButton: {
    padding: '13px 22px',
    borderRadius: '9999px',
    backgroundColor: neonLime,
    color: black,
    fontSize: '16px',
    lineHeight: '100%',
    textTransform: 'uppercase',
    fontFamily: 'GothamRounded',
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: neonLimeLight
    },
    '&:active': {
      backgroundColor: neonLimeDark
    }
  },
  invitationContent: {
    display: 'flex',
    boxSizing: 'border-box',
    padding: '0 25px',
    height: '100%',
    alignItems: 'stretch',
    justifyContent: 'center',
    '& > *': {
      flex: 1
    }
  },
  [MediaQueries.Tablet]: {
    invitationSplit: {
      boxSizing: 'border-box',
      padding: '34px 25px',
      height: '100%',
      alignItems: 'stretch',
      display: 'flex',
      '& > *': {
        flex: 1
      },
      maxWidth: ContentLimits[MediaQueries.Tablet]
    },
    invitationOverlay: {
      alignItems: 'flex-start'
    },
    invitationContent: {
      display: 'none'
    },
    header: {
      textAlign: 'start'
    }
  },
  [MediaQueries.LaptopSmall]: {
    invitationSplit: {
      maxWidth: ContentLimits[MediaQueries.LaptopSmall]
    },
    text: {
      textAlign: 'start'
    }
  },
  [MediaQueries.LaptopLarge]: {
    invitationSplit: {
      maxWidth: ContentLimits[MediaQueries.LaptopLarge]
    }
  }
})

export default useStyles
